import {useQuery} from 'react-query';
import {getPlanTransAction} from '.';
import {useNavigate} from 'react-router-dom';

const useGetLoadingTransactionPlan = (params: IGetPlanPaymentLoadingProps) => {
  const navigate = useNavigate();

  const {isLoading, data} = useQuery({
    queryKey: ['payment-loading-transaction', params],
    queryFn: () => getPlanTransAction(params),
    onSuccess(data) {
      data &&
        data.status &&
        navigate(
          data.status === 'successful'
            ? '/payment/plan/success'
            : `/payment/plan/failure/${params.ipg_type}/${params.transaction_guid}`,
          {state: {data}},
        );
    },
  });
  return {isLoading, data};
};

export default useGetLoadingTransactionPlan;
